import React from "react";
import { ThreeCircles } from "react-loader-spinner";

export default function LoadingE() {
  return (
    <div className="flex flex-col w-screen h-screen items-center justify-center  font-traffic text-custom-green-300  border-md p-5 ">
      <ThreeCircles
        wrapperStyle={{}}
        wrapperClass="dna-wrapper"
        height="120"
        width="120"
        color="#21AA58"
      />

      <p className="text-center text-xl">در حال ارتباط با سرور</p>
      <p className="text-center">لطفا صبر کنید...</p>
    </div>
  );
}
